import classNames from "classnames";
import PageToggle from "rivals/components/shared/PageToggle";
import { TOGGLE_VARIANTS } from "rivals/components/shared/PageToggle/types";
import styles from "./TeamsGroupingToggle.module.scss";
import strings from "./strings";
import type { Props } from "./types";

const { toggleItems } = strings;

const TeamsGroupingToggle = ({
  loading,
  onToggle,
  pageParams,
  philter
}: Props): JSX.Element | null => {
  return (
    <PageToggle
      activeTabClassName={styles.activeTab}
      className={classNames(styles.displayToggle, {
        [styles.hidden]: !!pageParams.group
      })}
      disabled={loading}
      items={toggleItems[pageParams.type]}
      onToggle={onToggle}
      philter={`${philter}-teams-grouping-toggle`}
      selected={pageParams.groupingType}
      variant={TOGGLE_VARIANTS.SPORTS}
    />
  );
};

export default TeamsGroupingToggle;
